const CALLBACK_NAME = '__googleMapsApiOnLoadCallback';
const GOOGLE_MAPS_URI = 'https://maps.googleapis.com/maps/api/js?';
let promise: Promise<undefined>;

declare global {
	interface Window {
		[CALLBACK_NAME: string]: () => void;
		google?: {
			maps: any
		};
	}
}

type LoadGoogleMapsProps = {
	key: string;
}
export default ({key}: LoadGoogleMapsProps) => {
	if (!promise) {
		promise = new Promise((resolve) => {
			const options = {
				key,
				v: '3',
				callback: CALLBACK_NAME
			};

			window[CALLBACK_NAME] = () => {
				// @ts-ignore
				resolve();
				delete window[CALLBACK_NAME];
			}

			const scriptElement = document.createElement('script');
			scriptElement.src = GOOGLE_MAPS_URI + Object.entries(options).map(([k, v]) => `${k}=${v}`).join('&');
			document.body.appendChild(scriptElement);
		});
	}

	return promise;
}
